import HowAISeesYourBrandContainer from "~/ui-rtk/components/features/dashboards/BrandPositioningHowAISeesYourBrand"

export default function HowAISeesYourBrand() {
  return <HowAISeesYourBrandContainer />
}
